import baseService from './apiService';

export async function getPublicSettings() {
    const response = await baseService.get(`/settings/public`);
    return response.data;
}
